import {combineReducers} from '@modifi/redux'
import {EntityState} from '@modifi/redux/lib/esm/factories/entity/reducer'
import {KeyWindowState} from '@modifi/redux/lib/esm/factories/collection/reducer'
import {PublicRegisteredCompanyView} from '@modifi/onboarding-api-clients'

import collectionReducer from './store/collection'
import selectedReducer, {PublicRegisteredCompanyDetailsWithProviderId} from './store/entity'
import resolvedCompanyReducer from './store/entity-resolution'

export default combineReducers({
  collection: collectionReducer,
  selected: selectedReducer,
  resolvedCompany: resolvedCompanyReducer,
})

export type PublicRegisteredCompaniesState = {
  collection: KeyWindowState<PublicRegisteredCompanyView>
  // @ts-expect-error to be fixed
  selected: EntityState<PublicRegisteredCompanyDetailsWithProviderId>
  // @ts-expect-error to be fixed
  resolvedCompany: EntityState<PublicRegisteredCompanyDetailsView>
}
